import { render } from "./ManageExpenseObject.vue?vue&type=template&id=a8a0fc9a"
import script from "./ManageExpenseObject.vue?vue&type=script&lang=js"
export * from "./ManageExpenseObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__